import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import { ucwords } from 'helper';
import BusinessActivity from './RenewalAssessApplication/BusinessActivity';
import * as c from '../constant';
import * as actions from '../actions';

function UpdateModal({
  assessRenewApplication,
  id,
  history,
  getItem,
  updating,
  updateList,
  getVetRegistrationList,
  vetRegistrationList,
}) {
  const [formData, setFormData] = useState({
    base_line: '',
    veterinary_fee_id: '',
    calculation_details: {},
    area: '',
    no_of_male_employees: '',
    no_of_female_employees: '',
    no_of_employees: '',
    no_of_employees_residing_manila: '',
    no_of_van: '',
    no_of_truck: '',
    no_of_motorcycle: '',
  });

  const [formDataCalculation, setFormDataCalculation] = useState({});
  const [calculateData, setCalculateData] = useState({});

  const commonValidation = {
    base_line: 'required|number',
    area: 'required|number',
    no_of_employees_residing_manila: 'required|number',
    no_of_male_employees: 'required|number',
    no_of_female_employees: 'required|number',
    no_of_van: 'required|number',
    no_of_truck: 'required|number',
    no_of_motorcycle: 'required|number',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  const validateCalculation = Object.keys(formDataCalculation)
    .map(item => {
      return { [item]: 'required|number' };
    })
    .values();

  const setValidateCalculation = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const value of validateCalculation) {
      setCalculateData(prevData => ({
        ...prevData,
        ...value,
      }));
    }
  };

  useEffect(() => {
    setValidateCalculation();
  }, [formDataCalculation]);

  const validateFormCalculation = useFormValidator(
    formDataCalculation,
    calculateData
  );

  useEffect(() => {
    validateFormCalculation.onSetObjectRules(calculateData);
  }, [formDataCalculation]);

  const setModal = useContext(ModalContext);

  useEffect(() => {
    getVetRegistrationList();
  }, []);

  const calculationDetails = _.get(
    updateList,
    'included.bplsApplication.attributes.calculation_details'
  );

  const handleOnSubmit = e => {
    e.preventDefault();
    if (
      !validateForm.response.is_passed &&
      !validateFormCalculation.response.is_passed
    ) {
      return false;
    }

    const args = {
      ...formData,
      // calculation details
      calculation_details: formDataCalculation,
      area: +_.get(formData, 'area'),
      base_line: +_.get(formData, 'base_line'),
      no_of_employees: +_.get(formData, 'no_of_employees'),
      no_of_employees_residing_manila: +_.get(
        formData,
        'no_of_employees_residing_manila'
      ),
      no_of_male_employees: +_.get(formData, 'no_of_male_employees'),
      no_of_female_employees: +_.get(formData, 'no_of_female_employees'),
      no_of_vehicles: +_.get(formData, 'no_of_vehicles'),
      no_of_van: +_.get(formData, 'no_of_van'),
      no_of_truck: +_.get(formData, 'no_of_truck'),
      no_of_motorcycle: +_.get(formData, 'no_of_motorcycle'),
    };

    return assessRenewApplication(id, args, () => {
      const pathName = history.location.pathname;
      setModal({ isOpen: false });
      getItem(id);

      if (pathName.indexOf('/bpls/applications/renewal') > -1) {
        return history.push(`/bpls/applications/renewal/${id}`);
      }
      return history.push(`/bpls/applications/new/${id}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const checkNumberOfEmployees = employeesData => {
    if (
      _.get(updateList, 'attributes.no_of_employees') === 0 ||
      _.get(updateList, 'attributes.no_of_employees') === '0'
    )
      return '0';
    if (
      _.get(updateList, 'attributes.no_of_employees') !== 0 ||
      _.get(updateList, 'attributes.no_of_employees') !== '0'
    ) {
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') !== 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') !== 0)
      )
        return '0';
      if (
        (employeesData === 0 || employeesData === '0') &&
        (_.get(updateList, 'attributes.no_of_male_employees') === 0 ||
          _.get(updateList, 'attributes.no_of_female_employees') === 0)
      )
        return '';
    }
    return employeesData;
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      const business = _.get(updateList, 'included.bplsBusiness.attributes');
      setFormData({
        ...formData,
        base_line: _.get(business, 'base_line') || '',
        calculation_details: _.get(business, 'calculation_details') || {},
        veterinary_fee_id: _.get(business, 'veterinary_fee_id') || '',
        area: _.get(business, 'area') || '',
        no_of_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : _.get(business, 'no_of_employees') || '',
        // eslint-disable-next-line eqeqeq
        no_of_employees_residing_manila:
          checkNumberOfEmployees(
            _.get(business, 'no_of_employees_residing_manila')
          ) || '',
        no_of_male_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : `${_.get(business, 'no_of_male_employees')}` || '',

        no_of_female_employees:
          // eslint-disable-next-line eqeqeq
          _.get(business, 'no_of_employees') == 0
            ? '0'
            : `${_.get(business, 'no_of_female_employees')}` || '',
        no_of_vehicles: _.get(business, 'no_of_vehicles') || '0',
        no_of_van: _.get(business, 'no_of_van') || '0',
        no_of_truck: _.get(business, 'no_of_truck') || '0',
        no_of_motorcycle: _.get(business, 'no_of_motorcycle') || '0',
      });
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(calculationDetails)) {
      setFormDataCalculation({
        ...formDataCalculation,
        ...calculationDetails,
      });
    }
  }, []);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeCalculationDetails = e => {
    setFormDataCalculation({
      ...formDataCalculation,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    validateFormCalculation.validate();
  }, []);

  // vet reg filter dropdown
  const listOption =
    vetRegistrationList.map(item => ({
      label: _.get(item, 'attributes.veterinary_registration'),
      value: _.get(item, 'id'),
    })) || '';

  const addedData = {
    label: 'Select',
    value: '',
  };

  const sortOption = (listOption || []).concat([addedData]);
  const vetRegistrationListOption = _.orderBy(sortOption, ['value'], ['asc']);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="container">
          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Business Operation
          </div>

          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Business Area/Total Floor Area (sq.m):{' '}
                {validateForm.renderMessage('area')}
              </label>
              <input
                className="form-control"
                type="text"
                name="area"
                onChange={onChange}
                value={_.get(formData, 'area') || ''}
                disabled
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Employees residing within Manila:{' '}
                {validateForm.renderMessage('no_of_employees_residing_manila')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_employees_residing_manila"
                onChange={onChange}
                value={_.get(formData, 'no_of_employees_residing_manila') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total Number of Male Employees:{' '}
                {validateForm.renderMessage('no_of_male_employees')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_male_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_male_employees') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Total Number of Female Employees:{' '}
                {validateForm.renderMessage('no_of_female_employees')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_female_employees"
                onChange={onChange}
                value={_.get(formData, 'no_of_female_employees') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Van Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_van')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_van"
                onChange={onChange}
                value={_.get(formData, 'no_of_van') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Truck Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_truck')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_truck"
                onChange={onChange}
                value={_.get(formData, 'no_of_truck') || ''}
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Number of Motorcycle Delivery Vehicle: (if applicable):{' '}
                {validateForm.renderMessage('no_of_motorcycle')}
              </label>
              <input
                className="form-control"
                type="text"
                name="no_of_motorcycle"
                onChange={onChange}
                value={_.get(formData, 'no_of_motorcycle') || ''}
              />
            </div>
          </div>

          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Calculation Details
          </div>
          <div className="row">
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Veterinary Registration:
              </label>
              <Select
                name="kind_of_ownership"
                placeholder="Select"
                onChange={handleOnChangeSelect('veterinary_fee_id')}
                options={vetRegistrationListOption}
                value={
                  vetRegistrationListOption.find(item => {
                    return (
                      `${_.get(formData, 'veterinary_fee_id')}` ===
                      _.get(item, 'value')
                    );
                  }) || ''
                }
              />
            </div>
            <div className="col-6 form-group">
              <label htmlFor="last_name" className="form-label mb-0">
                Base Line: {validateForm.renderMessage('base_line')}
              </label>
              <input
                className="form-control"
                type="text"
                name="base_line"
                onChange={onChange}
                value={_.get(formData, 'base_line') || ''}
                disabled
              />
            </div>
            {Object.entries(formDataCalculation).map((item, i) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={i} className="col-6 form-group">
                  <label htmlFor="last_name" className="form-label mb-0">
                    {ucwords(item[0].replace(/_/g, ' '))}:
                    {validateFormCalculation.renderMessage(`${item[0]}`)}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    name={item[0]}
                    onChange={onChangeCalculationDetails}
                    value={_.get(formDataCalculation, `${item[0]}`)}
                  />
                </div>
              );
            })}
          </div>
          <div className="row ml-auto text-primary font-weight-bold mb-2">
            Business Activities
          </div>
          <div className="form-wrapper p-3">
            <BusinessActivity updateList={updateList} businessId={id} />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={
              updating ||
              !validateForm.response.is_passed ||
              !validateFormCalculation.response.is_passed
            }
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>{' '}
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  assessRenewApplication: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  getVetRegistrationList: PropTypes.instanceOf(Function).isRequired,
  vetRegistrationList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  vetRegistrationList: _.get(api, `${c.GET_VET_REGISTRATION_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
